<script setup>
import {Icon} from "@iconify/vue";
import {Dialog, DialogOverlay, DialogPanel, TransitionChild, TransitionRoot} from "@headlessui/vue";
import Button from "@/components/Button/index.vue";
import {gregorianDate} from "@/utils/gregorianDate.js";
import {formatPrice} from "@/utils/priceFormatter.js";

const emit = defineEmits(['closeModal']);
const props = defineProps({
  data: Object
})

function closeModal() {
  emit('closeModal');
}
</script>

<template>
  <TransitionRoot appear show as="template">
    <Dialog as="div" @close="closeModal" class="relative z-[999]">
      <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-[black]/60"/>
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex h-full overflow-hidden items-center justify-center px-4 py-8">
          <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
          >
            <DialogPanel
                class="w-full flex flex-col overflow-hidden rounded-md max-w-lg text-left align-middle shadow-xl transition-all bg-white dark:bg-black-800 text-black-600 dark:text-white h-auto max-h-full">
              <div class="flex flex-row justify-between px-4 border-b border-slate-700">
                <div class="text-base py-3">
                  Transaction ID : {{ data.id }}
                </div>
                <div class="flex flex-row items-center gap-4">
                  <div class="h-full w-[1px] bg-slate-700"></div>
                  <button
                      type="button"
                      class="text-white-dark outline-none hover:text-red-500"
                      @click="closeModal"
                  >
                    <Icon icon="pajamas:close-xs"/>
                  </button>
                </div>
              </div>
              <div class="p-5 flex-1 overflow-auto h-full flex flex-col gap-6">
                <div class="divide-y divide-gray-700 text-sm">
                  <div class="grid grid-cols-[70px_1fr] gap-4 py-4">
                    <div class="">Amount</div>
                    <div class="">
                      <span dir="ltr" class="block w-full text-white whitespace-nowrap"
                            :class="{ '!text-red-400': data.amount < 0, '!text-success-500': data.amount > 0 }">
                        <template v-if="data.amount <= 0">
                          {{ data.amount ? formatPrice(data.amount) : '' }}
                        </template>
                        <template v-else>
                          {{ data.amount ? '+' + formatPrice(data.amount) : '' }}
                        </template>
                      </span>
                    </div>
                  </div>
                  <div class="grid grid-cols-[70px_1fr] gap-4 py-4 max-w-full">
                    <div class="">Title</div>
                    <div class="break-all">{{ data.title }}</div>
                  </div>
                  <div v-if="data.note" class="grid grid-cols-[70px_1fr] gap-4 py-4 max-w-full">
                    <div class="">Note</div>
                    <div class="break-all">{{ data.note }}</div>
                  </div>
                  <div class="grid grid-cols-[70px_1fr] gap-4 py-4">
                    <div class="">Date</div>
                    <div class="">{{ gregorianDate(data.datetime, 'HH:mm - DD MMM YYYY') }}</div>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<style scoped lang="scss">

</style>